
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');

 
const ImportsCoilsInsideMsilrAction = (props) => {
    const handleEventClick = (e) => {
        e.stopPropagation();
        //console.log("Overspeed ",props);
        //props.context.componentParent.onShowConsignmentImportsEventsClick(props);
        props.context.componentParent.onShowConsignmentExportsEventsClick(props);
    };
    
    if(props.data.status == 7)
    {
         var colr = 'greenfont'
    }
    else{
         var colr = 'grayfont'
    }
    return (
        <div>
            <button onClick={handleEventClick} className="custom-btn f22 label label-success" 
            title="Inside MSIL" ><i className={"icofont icofont-ui-home grayfont "+(colr)}></i> &nbsp;</button>
            
        </div>
    );
};

export default ImportsCoilsInsideMsilrAction;
